import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import Navlogo from '../images/Logo1.png';
import './css/ProfileAvatar.css'
export default function Navbar({ user, setUser }) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const logout = () => {
    localStorage.removeItem("user");
    setUser(null);
    navigate("/login");
  };

  const navItems = [
    { label: "Services", path: "/services" },
    { label: "Innovation", path: "/innovation" },
    { label: "Products", path: "/products" },
    { label: "Jobs", path: "/jobs" },
    { label: "About Us", path: "/aboutus" },
    { label: "Contact", path: "/contact" }
  ];

  const handleNavigate = (path) => {
    navigate(path);
    setIsMenuOpen(false);
  };

  // 🔥 Profile helpers
  const firstInitial =
    user?.name?.charAt(0)?.toUpperCase() || "?";

  return (
    <>
      <header className={`navbar-header ${isScrolled ? "navbar-scrolled" : "navbar-transparent"}`}>
        <div className="container navbar-content">

          {/* Logo */}
          <div className="logo" onClick={() => handleNavigate("/")}>
            <img src={Navlogo} alt="Nav Logo" width="250" height="70" />
          </div>

          {/* Desktop Menu */}
          <nav className="nav-desktop">
            {navItems.map((item) => (
              <button
                key={item.label}
                className="nav-link"
                onClick={() => handleNavigate(item.path)}
              >
                {item.label}
              </button>
            ))}

            {/* 🔥 AUTH AREA (LOGIC ONLY ADDED) */}
            {!user ? (
              <>
                <button className="nav-link" onClick={() => handleNavigate("/login")}>
                  Login
                </button>
                <button className="nav-link" onClick={() => handleNavigate("/register")}>
                  Sign up
                </button>
              </>
            ) : (
              <>

                <button className="nav-link" onClick={() => handleNavigate("/profile")}>
                  Profile
                </button>
                <button className="nav-link" onClick={logout}>
                  Logout
                </button>
                {user.picture ? (
                  <img
                    src={user.picture}
                    alt="profile"
                    className="nav-profile-pic"
                    referrerPolicy="no-referrer"
                  />
                ) : (
                  <div className="nav-profile-letter">
                    {firstInitial}
                  </div>
                )}
              </>
            )}
          </nav>

          {/* Mobile Toggle */}
          <button
            className="menu-toggle-btn nav-mobile-btn"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? "✕" : "☰"}
          </button>
        </div>
      </header>

      {/* Mobile Dropdown */}
<div className={`nav-mobile-dropdown ${isMenuOpen ? "nav-mobile-open" : ""}`}>
  {navItems.map((item) => (
    <button
      key={item.label}
      className="mobile-nav-item"
      onClick={() => handleNavigate(item.path)}
    >
      {item.label}
    </button>
  ))}

  {!user ? (
    <>
      <button
        className="mobile-nav-item"
        onClick={() => handleNavigate("/login")}
      >
        Login
      </button>
      <button
        className="mobile-nav-item"
        onClick={() => handleNavigate("/register")}
      >
        Sign up
      </button>
    </>
  ) : (
    <>
      <button
        className="mobile-nav-item"
        onClick={() => handleNavigate("/profile")}
      >
        Profile
      </button>
      <button
        className="mobile-nav-item"
        onClick={logout}
      >
        Logout
      </button>
    </>
  )}
</div>
    </>
  );
}
